export var ETooltipViewType;
(function (ETooltipViewType) {
  ETooltipViewType[ETooltipViewType["Popper"] = 0] = "Popper";
  ETooltipViewType[ETooltipViewType["Modal"] = 1] = "Modal";
})(ETooltipViewType || (ETooltipViewType = {}));